module.exports = __webpack_public_path__ + "static/media/main-background-mobile.941a4733.png";